import { SCREEN_PADDING, SCREEN_PADDING_LARGE } from '@/styles';
import { useSmallLayoutSizeValue } from '@/contexts/layout-context';

export const useOrderItemHorizontalSpace = () => {
  return useSmallLayoutSizeValue(SCREEN_PADDING, SCREEN_PADDING_LARGE);
};
